export const ROLES = {
  HOLDER: "HOLDER",
  ISSUER: "ISSUER",
  VERIFIER: "VERIFIER",
  ADMIN: "ADMIN",
};
export const RequestFilter = {
  ALL: "ALL",
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  ACCEPTED_OR_REJECTED: "ACCEPTED_OR_REJECTED",
};
export const RequestFilterIndex = {
  PENDING: 0,
  ACCEPTED: 1,
  REJECTED: 2,
  ALL: 3,
  ACCEPTED_OR_REJECTED: 4,
};
